
       
export function createXLSheetdata(kitchenList) {
    kitchenList.find((ticketDetails, index) => {
                
            delete kitchenList[index]['id']          
            delete kitchenList[index]['editAccess']                   
            delete kitchenList[index]['employee_pk_id']

            kitchenList[index].EmployeeCode=kitchenList[index].employee_id
            delete kitchenList[index]['employee_id']

            kitchenList[index].EmployeeName=kitchenList[index].employee_name
            delete kitchenList[index]['employee_name']
            
            delete kitchenList[index]['employee_mobile']
            
            kitchenList[index].employeeDesignation=kitchenList[index].employee_designation
            delete kitchenList[index]['employee_designation']
            
            kitchenList[index].WorkLocation=kitchenList[index].kitchen_work_location_name
            delete kitchenList[index]['kitchen_work_location_name']

            delete kitchenList[index]['kitchen_work_location_code']
            delete kitchenList[index]['kitchen_work_location_cluster_manager_id']
            delete kitchenList[index]['kitchen_work_location_city_manager_id']



            
            kitchenList[index].DeputedKitchenName=kitchenList[index].kitchen_name
            delete kitchenList[index]['kitchen_name']
            
            kitchenList[index].DeputedKitchenCode=kitchenList[index].kitchen_code
            delete kitchenList[index]['kitchen_code']
            
            kitchenList[index].DeputedCity=kitchenList[index].kitchen_code
            delete kitchenList[index]['kitchen_work_location_city_name']


            kitchenList[index].From=kitchenList[index].from_datetime
            delete kitchenList[index]['from_datetime']


            kitchenList[index].To=kitchenList[index].to_datetime
            delete kitchenList[index]['to_datetime']


            kitchenList[index].ApprovedBy=kitchenList[index].approved_by_name
            delete kitchenList[index]['approved_by_name']
            
            delete kitchenList[index]['approved_by_code']

            kitchenList[index].DeputeStatus=kitchenList[index].status
            delete kitchenList[index]['status']

            kitchenList[index].DeputeReason=kitchenList[index].reason
            delete kitchenList[index]['reason']

            kitchenList[index].DeputeRemarks=kitchenList[index].remarks
            delete kitchenList[index]['remarks']


           
            kitchenList[index].CreatedAt=kitchenList[index].created
            delete kitchenList[index]['created']
           
            return false

            })   
            return kitchenList
}



// WEBPACK FOOTER //
// ./src/modules/Employee Depute/services/helpers.js